import { Comment, CommentFilter, CommentFilterType } from 'features/collaboration/types'

export const defaultCommentsFilter: CommentFilter = {
  filter: CommentFilterType.All,
  showResolved: false,
  searchText: ''
}

export function localFilterComment(comment: Comment, { filter, showResolved }: CommentFilter) {
  if (showResolved === false && comment.resolved) return false
  if (filter === CommentFilterType.OnlyUnread && comment.read === true) return false
  return true
}

export function localFilterComments(comments: Comment[], filter: CommentFilter) {
  return comments.filter((comment) => localFilterComment(comment, { ...filter }))
}

export function sortComments<T extends Comment>(comments: T[], direction: 'newestFirst' | 'oldestFirst') {
  return comments.toSorted((a, b) => {
    // DATE is proper ISO string, we can compare them lexicographically
    return direction === 'newestFirst' ? (b.updatedAt < a.updatedAt ? -1 : 1) : b.updatedAt < a.updatedAt ? 1 : -1
  })
}
